import { CSSProperties, FC } from 'react';
import logo from './logo.svg';

interface DefaultLogoProps {
  style?: CSSProperties;
  altText?: string;
}

export const DefaultLogo: FC<DefaultLogoProps> = ({ style, altText }) => (
  <img style={{ minHeight: '100%', ...style }} src={logo} alt={altText ?? ''} />
);
